import type { NetworkLocateModel } from '@/types';
import { getFullUrl } from '@/api/helpers';

type ResolveNetworkResult = {
  settings: NetworkLocateModel | null;
  error: string | null;
};

export async function resolveNetwork(
  uri: string,
  fetchLocate: (url: string) => Promise<NetworkLocateModel | undefined>
): Promise<ResolveNetworkResult> {
  const fullURL = getFullUrl(uri);
  if (!fullURL) return { settings: null, error: 'Invalid domain' };

  const settings = await fetchLocate(fullURL);
  if (!settings) return { settings: null, error: 'Network not found' };

  return { settings, error: null };
}
